module.exports = __webpack_public_path__ + "img/pic11.32c66852.png";